/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './repost.defs.js'
export * as $defs from './repost.defs.js'
